module.exports = __webpack_public_path__ + "static/media/27-7.866f17f7.mp3";